import { UserFlagCollection } from '@api/Collections/User/UserFlagCollection';
import type { Ind } from '@api/Entities/Ind/Ind';
import type { UserFlag } from '@api/Entities/User/UserFlag';

export const getMatchingUserFlags = (ind: Ind, userFlags: UserFlag[]): Array<UserFlag> => {
  const flagged = ind.getFlagsColors();

  const filteredUserFlags = userFlags.filter((uf) => flagged.has(uf.getFlagColor()));

  return filteredUserFlags;
};
